module.exports = __webpack_public_path__ + "static/media/MHSBGREEN.d6071821.png";